import styled from 'styled-components'

export const Footer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  padding: 10px;
  background: #cacaca;
  img {
    flex: flex-shrink;
    width: 40px;
  }
  p {
    margin: 0;
    line-height: 1.3;
  }
`

export default Footer



// WEBPACK FOOTER //
// ./src/components/atoms/wizard/Footer.tsx